import { cacheTrack } from "../lib/trackCache.js";
import { toggleLike } from "../lib/likedTracks.js";
import { useIsLiked } from "../lib/useLikedTracks.js";
import "./LikeButton.css";

function HeartIcon(props: { filled: boolean }): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={props.filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 20.5s-7.5-4.6-10-9.3C.6 8 2 4.5 5.3 3.7c2-.5 4 .3 5.2 2 .4-.1.7-.1 1 0 1.2-1.7 3.2-2.5 5.2-2 3.3.8 4.7 4.3 3.3 7.5-2.5 4.7-10 9.3-10 9.3z" />
    </svg>
  );
}

/** Heart toggle shown wherever a track appears. Writes the track's metadata into the shared cache the first time it's liked. */
export function LikeButton(props: {
  smId: string;
  title: string;
  artist: string;
  className?: string;
}): React.JSX.Element {
  const liked = useIsLiked(props.smId);

  return (
    <button
      type="button"
      className={`like-button${liked ? " like-button--liked" : ""}${props.className ? ` ${props.className}` : ""}`}
      aria-pressed={liked}
      aria-label={liked ? "Unlike track" : "Like track"}
      onClick={() => {
        cacheTrack(props.smId, { title: props.title, artist: props.artist });
        toggleLike(props.smId);
      }}
    >
      <HeartIcon filled={liked} />
    </button>
  );
}
